// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore }  from "firebase/firestore";
import { getAuth }       from "firebase/auth";
import { getStorage }    from "firebase/storage";   // <-- necesario

const firebaseConfig = {
  apiKey:            "AIzaSyD0VEo4qDXNvXUi1eyfFcQGyc3WT0Kv4uA",
  authDomain:        "conelcorazon-b2c06.firebaseapp.com",
  projectId:         "conelcorazon-b2c06",
  storageBucket:     "conelcorazon-b2c06.firebasestorage.app",
  messagingSenderId: "972678813366",
  appId:             "1:972678813366:web:c33539399c95423bd6b817",
};

const app = initializeApp(firebaseConfig);

export const db      = getFirestore(app);
export const auth    = getAuth(app);
export const storage = getStorage(app);   // <-- exportar storage
